import { useState, useEffect } from "react";
import InputMask from "react-input-mask";
import {
  AddAdherenseStyle,
  AddAdherenseTitle,
  WrapContent,
  BackButton,
  ConfirmButton,
  Progress,
  WrapTitleAndSmallText2,
  AcceptButton,
  AddButton,
} from "../../styles/AddAdherense";
import { useNavigate } from "react-router-dom";
import { HOME_LOGGED } from "../../core/app-urls";
import styled from "styled-components";
import {
  FaEdit,
  FaTrash,
  FaInfoCircle,
  FaSave,
  FaPlus,
  FaPlusSquare,
} from "react-icons/fa";
import { sendSheet } from "../../data/provider/enterprise/api_enterprise";
import CircularProgress from "@mui/joy/CircularProgress";
import { getPlansByContract } from "../../data/services/enterprise_service";
import { getCities, getUnidades } from "../../data/services/form_contract";
import {
  ActionIcons,
  CloseButton,
  ErrorIcon,
  Input,
  SelectAddherense,
  Sidebar,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "../../styles/AllAdherense";
import { removeMask } from "../../utils/remove_mask";
import { getContractAssociatedInfo } from "../../data/services/crew_service";

export default function AllAdherense() {
  const navigate = useNavigate();
  const [data, setData] = useState<any[]>([]);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [indivContractID, setIndivContractID] = useState<number | null>(null);
  const [indivUnity, setIndivUnity] = useState<string | null>(null);
  const [editedData, setEditedData] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [newEntry, setNewEntry] = useState<any>({
    CPF: "",
    Nome: "",
    Telefone: "",
    CEP: "",
    Email: "",
    Bairro: "",
    Logradouro: "",
    Numero: "",
    Complemento: "",
    Id_categoria: "",
    Estado: "",
    Cidade: "",
    id_clube: "",
  });
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [unidades, setUnidades] = useState<any>([]);
  const [contracts, setContracts] = useState<
    {
      categoria: string;
      id_categoria: string;
      id_contrato: number;
      idContratoCategoria: number;
      valor: string;
      num_contrato: string;
      id_clube: string;
      nome_fantasia: string;
    }[]
  >([]);
  const [municipios, setMunicipios] = useState<any>([]);
  const [estados, setEstados] = useState<Set<string>>(new Set());

  useEffect(() => {
    const savedResults = localStorage.getItem("resultsList");
    if (savedResults) {
      setData(JSON.parse(savedResults));
    }

    const fetchUnidades = async () => {
      try {
        const { unidades } = await getUnidades();
        setUnidades(unidades);
      } catch (error) {
        console.error("Erro ao buscar unidades:", error);
      }
    };

    const fetchMunicipios = async () => {
      try {
        const { cities, states } = await getCities();
        setMunicipios(cities);
        setEstados(states);
      } catch (error) {
        console.error("Erro ao buscar municípios:", error);
      }
    };

    async function fetchContracts() {
      const response = await getPlansByContract();
      if (response.data) {
        setContracts(
          response.data.planos.map((plano) => ({
            categoria: plano.categoria,
            id_categoria: plano.idCategoria,
            id_contrato: plano.idContrato,
            idContratoCategoria: plano.idContratoCategoria,
            valor: plano.valor,
            num_contrato: plano.num_contrato,
            id_clube: plano.ID_CLUBE,
            nome_fantasia: plano.nome_fantasia,
          }))
        );
      }
    }
    fetchContracts();
    fetchMunicipios();
    fetchUnidades();
  }, []);

  const handleLogout = () => {
    navigate(HOME_LOGGED);
  };

  const handleEdit = (index: number) => {
    setEditIndex(index);
    setEditedData(data[index]);
  };

  const handleSaveEdit = (index: number) => {
    const updatedData = [...data];
    updatedData[index] = editedData;
    setData(updatedData);
    setEditIndex(null);
  };

  const handleDelete = (index: number) => {
    const updatedData = data.filter((_, i) => i !== index);
    setData(updatedData);
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    field: string
  ) => {
    setEditedData({
      ...editedData,
      [field]: e.target.value,
    });
  };

  const handleAddEntry = () => {
    const mandatoryFields = [
      "CPF",
      "Nome",
      "Telefone",
      "CEP",
      "Email",
      "Bairro",
      "Logradouro",
      "Numero",
      "Complemento",
      "Estado",
      "Cidade",
      "Id_categoria",
    ];

    const missing = mandatoryFields.filter((field) => {
      const valor = newEntry[field];
      return !valor || valor.toString().trim() === "";
    });

    if (missing.length > 0) {
      alert(
        `Preencha todos os campos obrigatórios:\n- ${missing.join("\n- ")}`
      );
      return;
    }

    const cidadeSelecionada = municipios.find(
      (m: any) =>
        m.nomeMunicipio === newEntry.Cidade && m.uf === newEntry.Estado
    );

    if (!cidadeSelecionada) {
      alert("Selecione corretamente Estado e Cidade");
      return;
    }

    const entryForApi = {
      ...newEntry,
      CPF: removeMask(newEntry.CPF),
      Telefone: removeMask(newEntry.Telefone),
      CEP: removeMask(newEntry.CEP),

      id_cidade: cidadeSelecionada.codigo,
      id_uf: cidadeSelecionada.codigoUf,
      Id_Empresa: localStorage.getItem("id"),
      Id_categoria: newEntry.Id_categoria,
      id_contrato: indivContractID,
    };

    const updatedData = [...data, entryForApi];
    setData(updatedData);
    localStorage.setItem("resultsList", JSON.stringify(updatedData));

    setNewEntry({
      CPF: "",
      Nome: "",
      Telefone: "",
      CEP: "",
      Email: "",
      Bairro: "",
      Logradouro: "",
      Numero: "",
      Complemento: "",
      Estado: "",
      Cidade: "",
      Id_categoria: "",
    });

    setSidebarOpen(false);
  };

  const handleSaveChanges = () => {
    setLoading(true);
    localStorage.setItem("resultsList", JSON.stringify(data));

    setTimeout(async () => {
      const storedData = localStorage.getItem("resultsList");
      if (storedData) {
        try {
          let parsedData = JSON.parse(storedData);
          parsedData = parsedData.map((item: any) => {
            const cpf = String(item.CPF).replace(/\D/g, "").padStart(11, "0");
            const telefoneLimpo = String(item.Telefone).replace(/\D/g, "");

            return {
              ...item,
              CPF: cpf,
              Telefone: telefoneLimpo,
            };
          });
          await sendSheet(parsedData);
          setLoading(false);
          setSuccess(true);
          localStorage.removeItem("resultsList");
        } catch (error) {
          setLoading(false);
          console.error(
            "Erro ao converter os dados do localStorage para JSON",
            error
          );
        }
      }
    }, 3000);
  };

  const handleSearchCpfSidebar = async (cpf: string) => {
    if (!cpf) return;

    try {
      const cpfLimpo = removeMask(cpf);
      const { contract } = await getContractAssociatedInfo(cpfLimpo);

      if (!contract) return;

      const cidadeEncontrada = municipios.find(
        (m: any) => String(m.codigo) === String(contract.idCidade)
      );

      setNewEntry((prev: any) => ({
        ...prev,
        Nome: contract.nome || "",
        Telefone: contract.telefoneEmp || "",
        Email: contract.emailCob || "",
        CEP: contract.cep || "",
        Logradouro: contract.logradouro || "",
        Bairro: contract.bairro || "",
        Numero: contract.numero || "",
        Estado: cidadeEncontrada?.uf || "",
        Cidade: cidadeEncontrada?.nomeMunicipio || "",
      }));
    } catch (error) {
      console.error("Erro ao buscar CPF:", error);
    }
  };

  const handlePlanChange = (
    e: React.ChangeEvent<HTMLSelectElement>,
    field: string
  ) => {
    const newCategoryId = Number(e.target.value);
    setEditedData((prev: any) => ({
      ...prev,
      [field]: newCategoryId,
    }));
  };

  const handleConfirm = () => {
    navigate(HOME_LOGGED);
  };

  const handleManualAdd = () => {
    setSidebarOpen(true);
    console.log(sidebarOpen, "sidebar");
  };

  return (
    <AddAdherenseStyle>
      <WrapContent>
        <BackButton onClick={handleLogout}>VOLTAR</BackButton>
        <WrapTitleAndSmallText2>
          <AddAdherenseTitle>Inclusão de Adesões</AddAdherenseTitle>
          {/* <FaPlusSquare
            size={34}
            style={{
              cursor: "pointer",
              marginLeft: "30px",
              marginTop: "10px",
              color: "#FF5641",
            }}
            onClick={handleManualAdd}
          /> */}
          <AddButton onClick={handleManualAdd}>Inclusão individual +</AddButton>
        </WrapTitleAndSmallText2>

        <TableContainer>
          <Table>
            <Thead>
              <tr>
                <Th>CPF</Th>
                <Th>NOME</Th>
                <Th>Email</Th>
                <Th>Telefone</Th>
                <Th>Plano</Th>
                <Th>AÇÕES</Th>
              </tr>
            </Thead>
            <Tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <Tr key={index}>
                    <Td error={item.error}>
                      {editIndex === index ? (
                        <input
                          type="text"
                          value={editedData.CPF}
                          onChange={(e) => handleInputChange(e, "CPF")}
                        />
                      ) : (
                        item.CPF
                      )}
                    </Td>
                    <Td error={item.error}>
                      {editIndex === index ? (
                        <input
                          type="text"
                          value={editedData.Nome}
                          onChange={(e) => handleInputChange(e, "Nome")}
                        />
                      ) : (
                        item.Nome
                      )}
                    </Td>
                    <Td error={item.error}>
                      {editIndex === index ? (
                        <input
                          type="text"
                          value={editedData.Email}
                          onChange={(e) => handleInputChange(e, "Email")}
                        />
                      ) : (
                        item.Email
                      )}
                    </Td>
                    <Td error={item.error}>
                      {editIndex === index ? (
                        <input
                          type="text"
                          value={editedData.Telefone}
                          onChange={(e) => handleInputChange(e, "Telefone")}
                        />
                      ) : (
                        item.Telefone
                      )}
                    </Td>

                    <Td>
                      {editIndex === index ? (
                        <select
                          value={editedData.Id_categoria || ""}
                          onChange={(e) => handlePlanChange(e, "Id_categoria")}
                        >
                          {contracts.map((plan) => (
                            <option
                              key={plan.id_categoria}
                              value={plan.id_categoria}
                            >
                              {plan.categoria} - R$ {plan.valor}
                            </option>
                          ))}
                        </select>
                      ) : (
                        contracts.find(
                          (plan) =>
                            Number(plan.id_categoria) ===
                            Number(item.Id_categoria)
                        )?.categoria || "Plano não encontrado"
                      )}
                    </Td>

                    <Td>
                      <ActionIcons>
                        {editIndex === index ? (
                          <FaSave onClick={() => handleSaveEdit(index)} />
                        ) : (
                          <FaEdit onClick={() => handleEdit(index)} />
                        )}
                        <FaTrash onClick={() => handleDelete(index)} />
                        {item.error && <ErrorIcon />}
                      </ActionIcons>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td
                    colSpan={5}
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    Nenhum dado disponível
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>

        {loading && (
          <Progress>
            <CircularProgress />
            <h1>Aguarde enquanto processamos os dados!</h1>
          </Progress>
        )}

        {!loading && success && (
          <>
            <h2 style={{ textAlign: "center" }}>Dados enviados com sucesso!</h2>
            <ConfirmButton onClick={handleConfirm}>Confirmar</ConfirmButton>
          </>
        )}

        {!loading && !success && data.length > 0 && (
          <ConfirmButton onClick={handleSaveChanges}>Salvar</ConfirmButton>
        )}
      </WrapContent>
      <Sidebar open={sidebarOpen}>
        <CloseButton onClick={() => setSidebarOpen(false)}>X</CloseButton>
        <h3>Adicionar Nova Adesão</h3>
        {Object.keys(newEntry).map((key) => {
          const requiredFields = ["Nome", "CPF", "Email", "Telefone"];
          const placeholderText = requiredFields.includes(key)
            ? `${key} *`
            : key;

          if (key === "Cidade") {
            const cidadesFiltradas = municipios.filter(
              (m: any) => m.uf === newEntry.Estado
            );

            return (
              <SelectAddherense
                key={key}
                value={newEntry.Cidade}
                disabled={!newEntry.Estado}
                onChange={(e) =>
                  setNewEntry({ ...newEntry, Cidade: e.target.value })
                }
              >
                <option value="">Selecione a Cidade</option>
                {cidadesFiltradas.map((city: any) => (
                  <option key={city.codigo} value={city.nomeMunicipio}>
                    {city.nomeMunicipio}
                  </option>
                ))}
              </SelectAddherense>
            );
          }

          if (key === "Estado") {
            return (
              <SelectAddherense
                key={key}
                value={newEntry.Estado}
                onChange={(e) => {
                  const ufSelecionado = e.target.value;
                  setNewEntry({
                    ...newEntry,
                    Estado: ufSelecionado,
                    Cidade: "",
                  });
                }}
              >
                <option value="">Selecione o Estado</option>
                {Array.from(estados).map((uf) => (
                  <option key={uf} value={uf}>
                    {uf}
                  </option>
                ))}
              </SelectAddherense>
            );
          }

          if (key === "Id_categoria") {
            return (
              <SelectAddherense
                key={key}
                value={newEntry.Id_categoria || ""}
                onChange={(e) => {
                  const selectedIdCategoria = Number(e.target.value);

                  const selectedPlan = contracts.find(
                    (plan) => Number(plan.id_categoria) === selectedIdCategoria
                  );

                  setNewEntry({
                    ...newEntry,
                    Id_categoria: selectedIdCategoria,
                    id_clube: selectedPlan?.id_clube || null,
                  });
                  setIndivUnity(selectedPlan?.nome_fantasia!);
                  setIndivContractID(selectedPlan?.id_contrato!);
                }}
              >
                <option value="">Selecione o Plano</option>

                {contracts.map((plan) => (
                  <option key={plan.id_categoria} value={plan.id_categoria}>
                    {plan.categoria} - R$ {plan.valor} - {plan.nome_fantasia}
                  </option>
                ))}
              </SelectAddherense>
            );
          }

          if (key === "id_clube") {
            return (
              <Input
                key={key}
                type="text"
                placeholder="Unidade"
                value={indivUnity || ""}
                readOnly
              />
            );
          }

          if (key === "CPF") {
            return (
              <InputMask
                key={key}
                mask="999.999.999-99"
                placeholder={placeholderText}
                value={newEntry[key]}
                onChange={(e) =>
                  setNewEntry({ ...newEntry, [key]: e.target.value })
                }
                onBlur={() => handleSearchCpfSidebar(newEntry.CPF)}
              >
                {(inputProps: any) => <Input {...inputProps} />}
              </InputMask>
            );
          }

          if (key === "Telefone") {
            return (
              <InputMask
                key={key}
                mask="(99) 99999-9999"
                placeholder={placeholderText}
                value={newEntry[key]}
                onChange={(e) =>
                  setNewEntry({ ...newEntry, [key]: e.target.value })
                }
              >
                {(inputProps: any) => <Input {...inputProps} />}
              </InputMask>
            );
          }

          if (key === "CEP") {
            return (
              <InputMask
                key={key}
                mask="99999-999"
                placeholder={placeholderText}
                value={newEntry[key]}
                onChange={(e) =>
                  setNewEntry({ ...newEntry, [key]: e.target.value })
                }
              >
                {(inputProps: any) => <Input {...inputProps} />}
              </InputMask>
            );
          }

          return (
            <Input
              key={key}
              type="text"
              placeholder={placeholderText}
              value={newEntry[key]}
              onChange={(e) =>
                setNewEntry({ ...newEntry, [key]: e.target.value })
              }
            />
          );
        })}

        <ConfirmButton onClick={handleAddEntry}>Adicionar</ConfirmButton>
      </Sidebar>
    </AddAdherenseStyle>
  );
}
